import React, { Component, PropTypes } from 'react';
const defaultProps = {
    className: '',
    percent: 0,
    prefixCls: 'progress-indicator__linear',
    strokeColor: '#23826F',
    strokeLinecap: 'round',
    strokeWidth: 1,
    style: {},
    trailColor: '#D9D9D9',
    trailWidth: 1
};

const propTypes = {
    className: PropTypes.string,
    percent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    prefixCls: PropTypes.string,
    strokeColor: PropTypes.string,
    strokeLinecap: PropTypes.oneOf(['butt', 'round', 'square']),
    strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    style: PropTypes.object,
    trailColor: PropTypes.string,
    trailWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export class LinearProgressBar extends Component {
    componentDidUpdate() {
        if (!this.path) {
            return;
        }
        const pathStyle = this.path.style;
        pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
        const now = Date.now();
        if (this.prevTimeStamp && now - this.prevTimeStamp < 100) {
            pathStyle.transitionDuration = '0s, 0s';
        }
        this.prevTimeStamp = Date.now();
    }
    render() {
        const {
            className,
            percent,
            prefixCls,
            strokeColor,
            strokeLinecap,
            strokeWidth,
            style,
            trailColor,
            trailWidth,
            ...restProps
        } = this.props;

        delete restProps.gapPosition;

        const pathStyle = {
            strokeDasharray: '100px, 100px',
            strokeDashoffset: `${100 - percent}px`,
            transition: 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear'
        };

        const center = strokeWidth / 2;
        const right = 100 - strokeWidth / 2;
        const pathString = `M ${strokeLinecap === 'round' ? center : 0},${center}
           L ${strokeLinecap === 'round' ? right : 100},${center}`;
        const viewBoxString = `0 0 100 ${strokeWidth}`;

        return (
            <svg
                className={`${prefixCls}-line ${className}`}
                viewBox={viewBoxString}
                preserveAspectRatio="none"
                style={style}
                {...restProps}
            >
                <path
                    className={`${prefixCls}-line-trail`}
                    d={pathString}
                    strokeLinecap={strokeLinecap}
                    stroke={trailColor}
                    strokeWidth={trailWidth || strokeWidth}
                    fillOpacity="0"
                />
                <path
                    className={`${prefixCls}-line-path`}
                    d={pathString}
                    strokeLinecap={strokeLinecap}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                    fillOpacity="0"
                    ref={path => {
                        this.path = path;
                    }}
                    style={pathStyle}
                />
            </svg>
        );
    }
}

LinearProgressBar.propTypes = propTypes;

LinearProgressBar.defaultProps = defaultProps;



// WEBPACK FOOTER //
// ./src/components/widgets/LinearProgressBar.js